import { List } from "immutable";

// Whether or not all records are selected. Used for the select all checkbox state.
export const selectedCheck = (byId: any, ids: List<number>) => {
  if (!ids) {
    return false;
  }

  const records = ids.map((pId: number) => byId.get(pId));

  if (records.size === 0) {
    return false;
  }

  return !records.find((record: any) => {
    return record?.selected === false;
  });
};

// Gets all the record ids that are selected
export const selectedIds = (byId: any, ids: List<number>) => {
  if (!ids || ids.size === 0) {
    return List();
  }

  const records = ids.map((id) => byId.get(id as number));

  return records
    .filter((record) => {
      return record?.selected === true;
    })
    .map((record) => record?.id);
};
